import { Component, OnInit, Output, EventEmitter, ViewChildren, ElementRef, QueryList, Input, ChangeDetectionStrategy } from "@angular/core";

import { EditAddressBaseComponent } from "@mypxplat/xplat/features";
import { UserService, StorageService, ProductService, BaseComponent, AdminService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { takeUntil, take } from "rxjs/operators";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-add-edit-group",
  templateUrl: "add-edit-group.component.html",
  standalone: false,
})
export class AddEditGroupComponent extends BaseComponent implements OnInit {
  @Output() groupAdded: EventEmitter<any> = new EventEmitter();
  @Input() group: {
    id?: string;
    name: string;
    description: string;
    snippet?: string;
  } = {
    name: "",
    description: "",
    snippet: "",
  };
  public saving: boolean;

  constructor(
    userService: UserService,
    public adminService: AdminService,
    public activeModal: NgbActiveModal
  ) {
    super(userService);
  }

  ngOnInit() {}

  save() {
    this.saving = true;
    if (this.group.id) {
      this.adminService.updateGroup(this.group.id, this.group).subscribe((result) => {
        this.activeModal.close();
        this.groupAdded.next(this.group);
        this.saving = false;
      });
    } else {
      this.adminService.createGroup(this.group).subscribe((result) => {
        this.activeModal.close();
        this.groupAdded.next(this.group);
        this.saving = false;
      });
    }
  }
}
